module.exports = __webpack_public_path__ + "static/media/profile.4077e188.png";